import React from 'react';
import { useNavigate } from 'react-router-dom';

const PaymentCanceledPage = () => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-red-50 p-4">
            <div className="bg-white p-8 rounded-lg shadow-md text-center max-w-md">
                <svg className="w-20 h-20 text-red-400 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                <h1 className="text-2xl font-bold text-gray-800 mb-2">Payment Canceled</h1>
                <p className="text-gray-600 mb-6">
                    Your payment was not completed. You have not been charged. Would you like to try again?
                </p>
                <div className="space-x-4">
                    <button
                        onClick={() => navigate('/premium-upgrade')}
                        className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-lg transition duration-300"
                    >
                        Try Again
                    </button>
                    <button
                        onClick={() => navigate('/dashboard')}
                        className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-6 rounded-lg transition duration-300"
                    >
                        Back to Dashboard
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PaymentCanceledPage;